import "./Register.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UsersRegister } from "../../Api/Services";
import { toast } from "react-toastify";

function Register() {
  const [inputValue, setInputValue] = useState({});
  const [flagLoading, setFlagLoading] = useState(false);

  const navigate = useNavigate();

  const LoginCheck = async () => {
    let validation = true;
    const regex = /^09\d{9}$/;

    if (regex.test(inputValue.userName)) {
      toast.error("شماره همراه معتبر نیست ");
      validation = false;
    }
    if (inputValue.userName === "") {
      toast.error("شماره همراه را وارد نمایید ");
      validation = false;
    }
    if (inputValue.nationalCode === "") {
      toast.error(" کد ملی را وارد نمایید ");
      validation = false;
    }
    if (inputValue.password === "") {
      toast.error("رمز عبور  را وارد نمایید ");
      validation = false;
    }
    if (inputValue.firstName === "") {
      toast.error("نام  را وارد نمایید ");
      validation = false;
    }
    if (inputValue.companyName === "") {
      toast.error("نام شرکت  را وارد نمایید ");
      validation = false;
    }
    if (inputValue.lastName === "") {
      toast.error("نام خانوادگی  را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setFlagLoading(true);
      try {
        const UsersRegisterData = await UsersRegister(inputValue);
        if (UsersRegisterData.status && UsersRegisterData.status === 200) {
          toast.success("ثبت نام  با موفقیت انجام شد");
          navigate("/Login");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setFlagLoading(false);
      }
    }
  };
  const loginByEnter = (e) => {
    if (e.key === "Enter") {
      LoginCheck();
    }
  };

  return (
    <>
      {flagLoading && (
        <div
          className="scopeLoading d-flex justify-content-center align-items-center"
          style={{ height: window.innerHeight }}
        >
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={flagLoading ? "startLoading" : "stateLoading"}>
        <div className="d-flex justify-content-center align-items-center">
          <div id="loginForm">
            <h2 className="text-center w-100 mt-2">ثبت نام</h2>
            <div className="p-5" onKeyPress={loginByEnter}>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="شماره همراه"
                  value={inputValue.username}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      username: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="کد ملی"
                  value={inputValue.nationalCode}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      nationalCode: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="password"
                  placeholder="رمز عبور"
                  value={inputValue.password}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      password: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="نام"
                  value={inputValue.firstName}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      firstName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="نام خانوادگی"
                  value={inputValue.lastName}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      lastName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="نام شرکت"
                  value={inputValue.companyName}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      companyName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center">
                <button className="loginButton mt-3" onClick={LoginCheck}>
                  ثبت نام
                </button>
              </div>
              <div
                onClick={() => {
                  navigate("/Login");
                }}
                className="d-flex justify-content-center pt-2"
              >
                <span className="text-info pointer">ورود</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
